"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BulkContractServiceFeeEditor = class BulkContractServiceFeeEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getItemFromInput(...args) {
        const [inputItems, fields] = args;
        const fieldNames = _.map(fields, 'name');
        let result = {};
        _.each(inputItems, (item, i) => {
            if (i === 0) {
                result = _.pick(item, fieldNames);
            }
            for (const { name, defaultValue } of fields) {
                if (result[name] != item[name]) {
                    result[name] = defaultValue;
                    continue;
                }
                if (_.isUndefined(result[name])) {
                    result[name] = defaultValue;
                    continue;
                }
                if (result[name] != null) {
                    result[name] = item[name];
                }
            }
        });
        result['$updates'] = _.reduce(fieldNames, (m, v) => _.set(m, v, false), {});
        return result;
    }
    getPayload(...args) {
        const [inputItems, item] = args;
        const updates = _.keys(_.pickBy(item.$updates, _.identity));
        if (!updates.length) {
            return;
        }
        const update = _.pick(item, updates);
        return {
            items: _.map(inputItems, item => ({
                id: item.id,
                etag: item.etag,
                value: update
            }))
        };
    }
    items;
    onItems(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("items");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    editableFields;
    labelAlign;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    item;
    async $$load_item() {
        return this.getItemFromInput(this.items, this.$data.editableFields);
    }
    currencies;
    async $$load_currencies() {
        return this.$fn.fetch('list_currency');
    }
    paymentMethods;
    async $$load_paymentMethods() {
        return this.$fn.fetch('list_payment_method')
            .then(data => _.reduce(data, (m, v, k) => _.set(m, v.id, this.$fn.pgettext('PaymentMethod', v.name))));
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['editableFields', 'labelAlign', 'formId', 'formName', 'item', 'currencies', 'paymentMethods', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                editableFields: [{
                        name: "valid_from",
                    },
                    {
                        name: "valid_to",
                    },
                    {
                        name: "amount",
                    },
                    {
                        name: "currency",
                    },
                    {
                        name: "unit",
                    },
                    {
                        name: "quantity",
                    },
                    {
                        name: "unit_of_quantity",
                    },
                    {
                        name: "inflation_indexed",
                    },
                    {
                        name: "transaction_notes",
                    },
                    {
                        name: "notes",
                    },
                ],
                labelAlign: "right",
                formId: null,
                formName: "BulkContractServiceFeeEditor",
                item: null,
                currencies: null,
                paymentMethods: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("BulkContractServiceFeeEditor|Title", "Bulk Edit"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_8890_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_8896_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_request_8894_getActionArgs($event) {
        return {
            operation: "bulk_update_contract_service_fee",
            data: this.getPayload(this.items, this.item),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_8890 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_8890_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_8889 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_8890,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_8889],
        });
        const act_2248226175642056_closeComponent_8892 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_8891 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_8892,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_8891],
        });
        const act_1040167445267876_closeModal_8896 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_8896_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_8895 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_8896,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_8894 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_8894_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_8895],
        });
        const evh_1040167445267876_submit_8893 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_8894,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_8893],
        });
        const act_1419464017721962_closeComponent_8898 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_8897 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_8898,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_8897],
        });
        return {
            act_7315092382398562_closeModal_8890,
            evh_7315092382398562_close_8889,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_8892,
            evh_2248226175642056_close_8891,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_8896,
            evh_1040167445267876_success_8895,
            act_1040167445267876_request_8894,
            evh_1040167445267876_submit_8893,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_8898,
            evh_1419464017721962_clickPreventStop_8897,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_request_8894,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Array,
    }),
    __metadata("design:type", typeof (_a = typeof array !== "undefined" && array) === "function" ? _a : Object)
], BulkContractServiceFeeEditor.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkContractServiceFeeEditor.prototype, "onItems", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], BulkContractServiceFeeEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BulkContractServiceFeeEditor.prototype, "onSize", null);
BulkContractServiceFeeEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], BulkContractServiceFeeEditor);
exports.default = BulkContractServiceFeeEditor;
vue_property_decorator_1.Vue.component("BulkContractServiceFeeEditor", BulkContractServiceFeeEditor);
